import { render } from "./ShowMessage.vue?vue&type=template&id=57ed04f4"
import script from "./ShowMessage.vue?vue&type=script&lang=ts"
export * from "./ShowMessage.vue?vue&type=script&lang=ts"

import "./ShowMessage.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script